import { useSelector } from "react-redux";

function Share() {
    const user = useSelector(state => state.user);
    return (
        <div class="modal fade" id="share" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" >
    <div class="modal-dialog">
    <div class="modal-content bg-dark">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Share Schedule</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p>Share this link with your friends so they can see your schedule.</p>
        <input type="text" class="form-control" value={window.location.origin+"/?shareId="+user.uid} readOnly/>
        
    
    </div>
    </div>
    </div>
    </div>
    )
}

export default Share;